import { render, staticRenderFns } from "./UiCheckbox.vue?vue&type=template&id=87cb7d82&scoped=true"
import script from "./UiCheckbox.vue?vue&type=script&lang=js"
export * from "./UiCheckbox.vue?vue&type=script&lang=js"
import style0 from "./UiCheckbox.vue?vue&type=style&index=0&id=87cb7d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cb7d82",
  null
  
)

export default component.exports